const CHIP_WIDTHS = [56, 72, 88, 64, 96, 80, 68];

type McpSkillsChipsPreloadProps = {
  chips?: number;
};

/** Skeleton chips row matching category filters on `/chat/skills`. */
export function McpSkillsChipsPreload({ chips = 5 }: McpSkillsChipsPreloadProps) {
  return (
    <div
      className="mcp-skills-chips placeholder-glow"
      aria-hidden
      style={{ pointerEvents: 'none' }}
    >
      <span
        className="placeholder rounded-pill d-inline-block"
        style={{ width: 48, height: 30 }}
      />
      {Array.from({ length: chips }, (_, index) => (
        <span
          key={index}
          className="placeholder rounded-pill d-inline-block"
          style={{
            width: CHIP_WIDTHS[index % CHIP_WIDTHS.length],
            height: 30
          }}
        />
      ))}
    </div>
  );
}
